import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "order-amount" }
const _hoisted_2 = {
  key: 0,
  class: "order-amount__title"
}

import { computed, type PropType } from 'vue';

import type { MarketModel } from '@exchange/libs/market/service/src';
import { MyOrdersListType } from '@exchange/libs/order/shared-model/src/lib/order-essentials';
import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderAmount',
  props: {
  listType: { type: String as PropType<MyOrdersListType>, required: true },
  market: { type: Object as PropType<MarketModel> },
  mobile: { type: Boolean, default: false },
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
},
  setup(__props) {

const props = __props;

const amount = computed(() => (props.listType === MyOrdersListType.filled ? props.order.displayFilledAmount : props.order.amount));

return (_ctx: any,_cache: any) => {
  const _component_ot_number_display = _resolveComponent("ot-number-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.mobile)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('modules.myOrders.header.amount')) + ":", 1))
      : _createCommentVNode("", true),
    _createVNode(_component_ot_number_display, {
      class: "order-amount__value",
      number: amount.value,
      precision: __props.order.getAmountPrecision(__props.market),
      suffix: __props.order.amountSuffix
    }, null, 8, ["number", "precision", "suffix"])
  ]))
}
}

})